<template>
  <div>
    <page-title>Forms</page-title>

    <loading v-if="loading" />

    <main class="p-forms-index" v-else>
      <tabs v-if="$route.meta.isAdmin">
        <tabs-item
          :key="adminTabs.indexOf(tab)"
          v-for="tab in adminTabs"
          :link="tab.to"
          >{{ tab.title }}</tabs-item
        >
      </tabs>

      <section-block>
        {{ searchQuery }}
        <template slot="header">
          <filter-bar
            resource="Forms"
            :search-query="searchQuery"
            show-search
            show-filter
            :filter-options="categories"
          ></filter-bar>
        </template>

        <template slot="actions" v-if="$route.meta.isAdmin">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminFormCreatePage' })"
            iconBefore="document-create"
          >
            <span>Add a form</span>
          </base-button>
        </template>
        <base-empty v-if="!forms || forms.length < 1">
          <p>There are no forms created yet.</p>
        </base-empty>

        <vuetable
          v-else
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data="forms"
          @vuetable:row-clicked="gotoForm"
        >
          <template slot="form-name" slot-scope="props">
            <div class="c-data-table__cell-icon">
              <span>{{ props.rowData.current_version.title }}</span>
            </div>
          </template>

          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>
          <template slot="category" slot-scope="props">{{
            props.rowData.category.name
          }}</template>

          <template slot="category-actions" slot-scope="props">
            <base-button @click="gotoForm" :primary="true">View</base-button>
          </template>
        </vuetable>
      </section-block>
    </main>
  </div>
</template>

<script>
const CategoryActions = () => import('@/components/CategoryActions');
const BaseEmpty = () => import('@/components/elements/BaseEmpty');
import { mapState } from 'vuex';
import DropdownAction from '@/components/DropdownAction';
export default {
  name: 'AdminFormIndexPage',
  components: {
    BaseEmpty,
    CategoryActions,
    DropdownAction,
  },
  mixins: [],
  props: {},
  data() {
    return {
      loading: true,
      searchQuery: '',
      adminTabs: [
        {
          to: `/admin/eforms/`,
          title: `Approved`,
        },
        {
          to: `/admin/eforms/pending`,
          title: 'Awaiting Approval',
        },
        {
          to: `/admin/eforms/review`,
          title: 'For Review',
        },
        {
          to: `/admin/eforms/lapsed`,
          title: `Lapsed`,
        },
        {
          to: `/admin/eforms/rejected`,
          title: `Rejected`,
        },
      ],
      table: {
        fields: [
          {
            name: 'form-name',
            title: 'Form Name',
            titleClass: 'u-ta-left',
            dataClass: 'u-ta-left title-col',
            width: '40%',
          },

          {
            name: 'category',
            titleClass: 'u-ta-left',
            title: 'Category',
            width: '20%',
          },
          {
            name: 'date-created',
            titleClass: 'u-ta-left',
            title: 'Date Created',
            width: '20%',
          },
          {
            name: 'category-actions',
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('Forms', ['forms']),
    ...mapState('FormCategories', ['categories']),
  },
  watch: {},
  beforeCreate() {},
  async created() {
    this.$store.commit('Forms/setSortBy', {
      direction: 'asc',
      field: 'eform_title.raw',
    });
    await this.$store.dispatch('FormCategories/list', { flat: true });
    await this.$store.dispatch('Forms/list');
    this.loading = false;
  },
  methods: {
    gotoForm(row) {
      if (row.event.target.localName === 'td' || row.event.target.parentNode.localName === 'td' === 'td') {
        this.$router.push({
          path: `/forms${row.data.eform_url}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
td > td {
  border: none;
  padding: 0;
  display: inline-block;
}
</style>
